export default "__VITE_ASSET__DgJRs3KZ__"